import DatePickerCustomDay from "components/DatePickerCustomDay";
import DatePickerCustomHeaderTwoMonth from "components/DatePickerCustomHeaderTwoMonth";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import React, { FC, useState } from "react";
import DatePicker from "react-datepicker";
import CommonLayout from "./CommonLayout";
import { useSelector } from "react-redux";
import { selectCurrentProperty } from "application/features/property/propertySlice";
import CommonListingCardH from "components/CommonListingCardH/CommonListingCardH";

export interface PageAddListing9Props { }

const PageAddListing9: FC<PageAddListing9Props> = () => {
  const property = useSelector(selectCurrentProperty);
  const [dates, setDates] = useState<number[]>([
    new Date("2023/02/06").getTime(),
    new Date("2023/02/09").getTime(),
    new Date("2023/02/15").getTime(),
  ]);

  return (
    <CommonLayout
      index="09"
      backtHref="/add-listing-8"
      nextHref="/add-listing-10"
    >
      <>
        <div>
          <h2 className="text-2xl font-semibold">How long can guests stay?</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {` Shorter trips can mean more reservations, but you'll turn over your
          space more often.`}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <div className="space-y-7">
          {/* ITEM */}
          <NcInputNumber label="Nights min" defaultValue={1} />
          <NcInputNumber label="Nights max" defaultValue={99} />
        </div>

        {/*  */}
        <div>
          <h2 className="text-2xl font-semibold">Set your availability</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Editing your calendar is easy—just select a date to block or unblock
            it. You can always make changes after you publish.
          </span>
        </div>

        <div className="addListingDatePickerExclude">
          <DatePicker
            onChange={(date) => {
              let newDates = [];

              if (!date) {
                return;
              }
              const newTime = date.getTime();
              if (dates.includes(newTime)) {
                newDates = dates.filter((item) => item !== newTime);
              } else {
                newDates = [...dates, newTime];
              }
              setDates(newDates);
            }}
            selected={new Date("2023/02/06")}
            monthsShown={2}
            showPopperArrow={false}
            excludeDates={dates.filter(Boolean).map((item) => new Date(item))}
            inline
            renderCustomHeader={(p) => (
              <DatePickerCustomHeaderTwoMonth {...p} />
            )}
            renderDayContents={(day, date) => (
              <DatePickerCustomDay dayOfMonth={day} date={date} />
            )}
          />
        </div>
        {/* PREVIEW */}
        <div className="flex flex-col gap-4 mt-8">
          <h3 className="text-xl font-semibold">Anteprima</h3>
          <p className="text-sm text-neutral-500 dark:text-neutral-400">Ecco come apparirà il tuo annuncio.</p>
          <div className="flex flex-col mt-4">
            <CommonListingCardH
              name={property?.name || ""}
              price={property?.price || 0}
              description={property?.description || ""}
              rating={property?.rating || 0}
              reviews_count={property?.reviews_count || 0}
              max_guests={property?.max_guests || 0}
              author={{
                displayName: property?.author?.displayName || "",
                avatar: property?.author?.avatar || ""
              }}
              cover={property?.cover || ""}
              gallery_images={property?.gallery_images || []}
              href="#"
              showAuthor={false}
              isLiked={false}
              showButtons={false}
              priceType="person"
            />
          </div>
        </div>
      </>
    </CommonLayout>
  );
};

export default PageAddListing9;
